var _style, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolkadotNewDotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1326.1 1410.3",
    style: {
      enableBackground: "new 0 0 1326.1 1410.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6007A;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 663,
    cy: 147.9,
    rx: 254.3,
    ry: 147.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 663,
    cy: 1262.3,
    rx: 254.3,
    ry: 147.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -279.1512 369.5916)",
    className: "st0",
    cx: 180.5,
    cy: 426.5,
    rx: 254.3,
    ry: 148
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -279.1552 1483.9517)",
    className: "st0",
    cx: 1145.6,
    cy: 983.7,
    rx: 254.3,
    ry: 147.9
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -467.6798 222.044)",
    className: "st0",
    cx: 180.5,
    cy: 983.7,
    rx: 148,
    ry: 254.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -59.8007 629.9254)",
    className: "st0",
    cx: 1145.6,
    cy: 426.6,
    rx: 147.9,
    ry: 254.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadotNewDotLogo);
export default __webpack_public_path__ + "static/media/polkadot-new-dot-logo.4345f3e48698d0e1e9362232d5a0e99f.svg";
export { ForwardRef as ReactComponent };